module.exports = __webpack_public_path__ + "static/img/16.e00d64c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/zh/16.png
// module id = 4Itf
// module chunks = 0